import React from 'react';
import { motion } from 'framer-motion';
import './LegalPages.css';

const Privacy = () => {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="container">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Politica de <span className="gradient-text">Confidențialitate</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Ultima actualizare: 4 Februarie 2026
          </motion.p>
        </div>
      </div>

      <div className="container legal-content">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <section className="legal-section">
            <h2>1. Introducere</h2>
            <p>
              Euro Taxi SRL, operatorul platformei suceava.taxi, este angajată să vă protejeze confidențialitatea și să asigure transparența în procesarea datelor personale. Această Politică de Confidențialitate explică cum colectăm, folosim, stocăm și protejăm informațiile dvs. personale în conformitate cu Regulamentul General privind Protecția Datelor (GDPR) și legislația aplicabilă din România și Uniunea Europeană.
            </p>
            <div className="highlight">
              <p>
                <strong>Responsabil cu prelucrarea datelor:</strong> Euro Taxi SRL, cu sediul în Suceava, România. Prin utilizarea serviciilor noastre, sunteți de acord cu practicile descrise în această politică.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>2. Informațiile pe Care le Colectăm</h2>
            <p>Colectăm diferite tipuri de informații pentru a furniza și îmbunătăți serviciile noastre:</p>

            <h3>2.1 Informații Furnizate Direct de Dvs.</h3>
            <ul>
              <li><strong>Date de cont:</strong> Nume, prenume, adresă de email, număr de telefon, dată de naștere</li>
              <li><strong>Informații de plată:</strong> Detalii card bancar, istoricul tranzacțiilor (procesate securizat prin furnizori terți)</li>
              <li><strong>Documente de identificare:</strong> Pentru șoferi - permis de conducere, asigurare vehicul, certificat de cazier</li>
              <li><strong>Fotografii de profil:</strong> Imagine opțională pentru personalizarea contului</li>
              <li><strong>Preferințe de călătorie:</strong> Locații favorite, setări de comunicare</li>
            </ul>

            <h3>2.2 Informații Colectate Automat</h3>
            <ul>
              <li><strong>Date de localizare GPS:</strong> Locația în timp real în timpul cursei, puncte de plecare și destinație</li>
              <li><strong>Informații despre dispozitiv:</strong> Model telefon, sistem de operare, identificatori unici, adresă IP</li>
              <li><strong>Date de utilizare:</strong> Istoricul curselor, evaluări, interacțiuni cu aplicația</li>
              <li><strong>Cookies și tehnologii similare:</strong> Pentru funcționalitatea aplicației și analize</li>
            </ul>

            <h3>2.3 Informații de la Terți</h3>
            <ul>
              <li>Servicii de cartografiere și navigație (Google Maps)</li>
              <li>Procesatori de plăți pentru verificarea tranzacțiilor</li>
              <li>Servicii de verificare a identității pentru șoferi</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Cum Folosim Datele</h2>
            <p>Prelucrăm datele dvs. personale pentru următoarele scopuri legitime:</p>

            <h3>3.1 Furnizarea Serviciilor</h3>
            <ul>
              <li>Conectarea pasagerilor cu șoferi disponibili în apropierea dvs.</li>
              <li>Procesarea și finalizarea plăților pentru curse</li>
              <li>Furnizarea suportului clienți și rezolvarea problemelor</li>
              <li>Trimiterea de notificări despre statusul cursei</li>
            </ul>

            <h3>3.2 Siguranță și Securitate</h3>
            <ul>
              <li>Verificarea identității șoferilor și prevenirea fraudei</li>
              <li>Monitorizarea activității suspecte și protejarea împotriva abuzurilor</li>
              <li>Investigarea incidentelor de siguranță sau reclamațiilor</li>
              <li>Păstrarea înregistrărilor pentru conformitate legală</li>
            </ul>

            <h3>3.3 Îmbunătățiri și Analize</h3>
            <ul>
              <li>Analizarea modelelor de utilizare pentru îmbunătățirea serviciilor</li>
              <li>Dezvoltarea de noi funcționalități și caracteristici</li>
              <li>Efectuarea de cercetări de piață și studii demografice</li>
              <li>Optimizarea algoritmilor de matching pasager-șofer</li>
            </ul>

            <h3>3.4 Comunicare și Marketing</h3>
            <ul>
              <li>Trimiterea de actualizări despre servicii și noi funcționalități</li>
              <li>Comunicări promoționale (cu consimțământul dvs., pe care îl puteți retrage)</li>
              <li>Sondaje de satisfacție și cereri de feedback</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Temeiuri Juridice pentru Prelucrare</h2>
            <p>Conform GDPR, prelucrăm datele dvs. pe baza următoarelor temeiuri legale:</p>
            <ul>
              <li><strong>Executarea contractului:</strong> Pentru furnizarea serviciilor de transport solicitate</li>
              <li><strong>Consimțământ:</strong> Pentru comunicări de marketing și anumite cookies</li>
              <li><strong>Interese legitime:</strong> Pentru prevenirea fraudei, îmbunătățirea serviciilor, analize</li>
              <li><strong>Obligații legale:</strong> Pentru conformitatea cu legislația fiscală, contabilă și de transport</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Partajarea și Divulgarea Datelor</h2>
            <p>Nu vindem datele dvs. personale. Partajăm informații doar în următoarele circumstanțe:</p>

            <h3>5.1 Cu Șoferi și Pasageri</h3>
            <ul>
              <li>Nume, evaluare, fotografie de profil pentru identificare</li>
              <li>Număr de telefon (mascat) pentru coordonarea cursei</li>
              <li>Locație pentru realizarea serviciului de transport</li>
            </ul>

            <h3>5.2 Furnizori de Servicii Terți</h3>
            <ul>
              <li><strong>Procesatori de plăți:</strong> Pentru procesarea tranzacțiilor securizate</li>
              <li><strong>Servicii cloud:</strong> Pentru stocarea și gestionarea datelor (AWS, Google Cloud)</li>
              <li><strong>Servicii de analiză:</strong> Pentru înțelegerea comportamentului utilizatorilor (Google Analytics)</li>
              <li><strong>Servicii de comunicare:</strong> Pentru trimiterea de SMS-uri și notificări push</li>
            </ul>

            <h3>5.3 Autorități și Obligații Legale</h3>
            <ul>
              <li>Autorități fiscale și organisme de reglementare</li>
              <li>Forțe de ordine, la cerere legală sau pentru investigații</li>
              <li>În cazul unei fuziuni, achiziții sau restructurări a companiei</li>
            </ul>

            <div className="highlight">
              <p>
                Toți partenerii noștri sunt obligați contractual să protejeze datele dvs. și să le folosească doar pentru scopurile specificate.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>6. Transferul Internațional al Datelor</h2>
            <p>
              Datele dvs. pot fi transferate și procesate în afara Spațiului Economic European (SEE) atunci când folosim servicii cloud sau furnizori internaționali. În astfel de cazuri, asigurăm protecția adecvată prin:
            </p>
            <ul>
              <li>Clauze contractuale standard aprobate de Comisia Europeană</li>
              <li>Certificări de adecvare (ex: EU-US Data Privacy Framework)</li>
              <li>Măsuri de securitate tehnice și organizatorice suplimentare</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Păstrarea Datelor</h2>
            <p>Păstrăm datele dvs. personale doar atât timp cât este necesar pentru scopurile pentru care au fost colectate:</p>
            <ul>
              <li><strong>Conturi active:</strong> Pe durata utilizării serviciilor noastre</li>
              <li><strong>Istoricul curselor:</strong> 7 ani (pentru conformitate fiscală și legală)</li>
              <li><strong>Date de plată:</strong> Conform cerințelor procesatorilor de plăți (de obicei 13 luni)</li>
              <li><strong>Conturi inactive:</strong> Ștergere după 3 ani de inactivitate</li>
              <li><strong>Date de marketing:</strong> Până la retragerea consimțământului</li>
            </ul>
            <p>
              După expirarea perioadelor de păstrare, datele sunt șterse securizat sau anonimizate pentru analize statistice.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Drepturile Dvs. conform GDPR</h2>
            <p>Aveți următoarele drepturi privind datele dvs. personale:</p>

            <h3>8.1 Dreptul de Acces</h3>
            <ul>
              <li>Să solicitați o copie a datelor personale pe care le deținem despre dvs.</li>
              <li>Să primiți informații despre cum sunt procesate datele dvs.</li>
            </ul>

            <h3>8.2 Dreptul de Rectificare</h3>
            <ul>
              <li>Să corectați datele inexacte sau incomplete</li>
              <li>Să actualizați informațiile de contact și preferințele</li>
            </ul>

            <h3>8.3 Dreptul la Ștergere ("Dreptul de a fi uitat")</h3>
            <ul>
              <li>Să solicitați ștergerea datelor în anumite circumstanțe</li>
              <li>Nu se aplică când păstrarea este necesară pentru obligații legale</li>
            </ul>

            <h3>8.4 Dreptul la Restricționarea Prelucrării</h3>
            <ul>
              <li>Să solicitați limitarea modului în care folosim datele dvs.</li>
              <li>Aplicabil în perioada de verificare a exactității datelor</li>
            </ul>

            <h3>8.5 Dreptul la Portabilitatea Datelor</h3>
            <ul>
              <li>Să primiți datele dvs. într-un format structurat, utilizat frecvent</li>
              <li>Să transferați datele către un alt furnizor de servicii</li>
            </ul>

            <h3>8.6 Dreptul de Opoziție</h3>
            <ul>
              <li>Să vă opuneți prelucrării bazate pe interese legitime</li>
              <li>Să refuzați comunicările de marketing în orice moment</li>
            </ul>

            <h3>8.7 Drepturi Privind Deciziile Automatizate</h3>
            <ul>
              <li>Să nu fiți supus deciziilor bazate exclusiv pe prelucrare automatizată</li>
              <li>Să solicitați intervenția umană în procesele de evaluare</li>
            </ul>

            <div className="highlight">
              <p>
                <strong>Pentru a vă exercita drepturile,</strong> contactați-ne la <strong>privacy@suceava.taxi</strong> sau prin setările aplicației. Vom răspunde în termen de 30 de zile.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>9. Cookies și Tehnologii de Urmărire</h2>
            <p>
              Folosim cookies și tehnologii similare pentru funcționalitatea aplicației, personalizare și analize:
            </p>

            <h3>9.1 Tipuri de Cookies</h3>
            <ul>
              <li><strong>Cookies esențiale:</strong> Necesare pentru funcționarea de bază a aplicației</li>
              <li><strong>Cookies de performanță:</strong> Pentru măsurarea și îmbunătățirea performanței</li>
              <li><strong>Cookies funcționale:</strong> Pentru memorarea preferințelor dvs.</li>
              <li><strong>Cookies de marketing:</strong> Pentru personalizarea reclamelor (cu consimțământ)</li>
            </ul>

            <h3>9.2 Gestionarea Cookies</h3>
            <p>
              Puteți controla și șterge cookies prin setările browser-ului dvs. Dezactivarea anumitor cookies poate afecta funcționalitatea aplicației.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Securitatea Datelor</h2>
            <p>
              Implementăm măsuri tehnice și organizatorice riguroase pentru protejarea datelor dvs. împotriva accesului neautorizat, pierderii sau distrugerii:
            </p>
            <ul>
              <li><strong>Criptare:</strong> Toate datele sensibile sunt criptate în tranzit (TLS/SSL) și în repaus (AES-256)</li>
              <li><strong>Autentificare:</strong> Autentificare cu doi factori pentru conturi și acces restricționat pe bază de roluri</li>
              <li><strong>Monitorizare:</strong> Sisteme de detectare a intruziunilor și audit log-uri comprehensive</li>
              <li><strong>Backup-uri:</strong> Copii de siguranță regulate cu criptare și stocare securizată</li>
              <li><strong>Formare personal:</strong> Training periodic privind securitatea datelor și confidențialitatea</li>
              <li><strong>Testare securitate:</strong> Audituri și teste de penetrare regulate</li>
            </ul>
            <p>
              Cu toate acestea, nicio metodă de transmitere prin internet nu este 100% sigură. Vă încurajăm să protejați datele de autentificare ale contului dvs.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Confidențialitatea Minorilor</h2>
            <p>
              Serviciile noastre sunt destinate persoanelor cu vârsta de minimum 18 ani. Nu colectăm intenționat date personale de la minori fără consimțământul părinților sau tutorilor legali.
            </p>
            <p>
              Dacă descoperim că am colectat date de la un minor fără consimțământ adecvat, vom lua măsuri pentru a șterge acele informații cât mai curând posibil.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Modificări ale Politicii de Confidențialitate</h2>
            <p>
              Ne rezervăm dreptul de a actualiza această Politică de Confidențialitate periodic pentru a reflecta modificările în practicile noastre sau cerințele legale.
            </p>
            <ul>
              <li>Modificările majore vor fi comunicate prin email sau notificări în aplicație</li>
              <li>Data "Ultima actualizare" de la începutul acestui document va fi actualizată</li>
              <li>Vă încurajăm să revizuiți periodic această politică</li>
              <li>Utilizarea continuă a serviciilor după modificări constituie acceptarea noii politici</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>13. Autoritate de Supraveghere</h2>
            <p>
              Dacă considerați că drepturile dvs. privind protecția datelor au fost încălcate, aveți dreptul să depuneți o plângere la:
            </p>
            <div className="highlight">
              <p>
                <strong>Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)</strong><br/>
                B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, București<br/>
                Tel: +40 318 059 211 | Email: anspdcp@dataprotection.ro<br/>
                Website: www.dataprotection.ro
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>14. Informații de Contact</h2>
            <p>
              Pentru orice întrebări, preocupări sau solicitări legate de această Politică de Confidențialitate sau prelucrarea datelor dvs. personale, vă rugăm să ne contactați:
            </p>
            <ul>
              <li><strong>Email pentru confidențialitate:</strong> privacy@suceava.taxi</li>
              <li><strong>Suport general:</strong> contact@suceava.taxi</li>
              <li><strong>Telefon:</strong> 0744 511 111 sau 0230 511 111</li>
              <li><strong>Adresă poștală:</strong> Euro Taxi SRL, Suceava, România</li>
            </ul>
            <p>
              Vom răspunde la solicitările dvs. în conformitate cu termenele legale aplicabile (de obicei în termen de 30 de zile).
            </p>
          </section>
        </motion.div>
      </div>
    </div>
  );
};

export default Privacy;
